<template>

    <div class="color-picker-group" :ref="elementRef">

        <b-form-group>

            <label>{{colorPickerName}}</label>

            <div class="color-picker-wrapper-field" @click="showPicker(theColorPicker,elementRef)" :class="this[theColorPicker] ? 'partial-width' : ''">

                <div class="color-picker-wrapper-field-preview" 
                :style="{background:settingsFromWeebly.settings[elementRef] }" ></div>
   
                <!-- hide color picker -->
                <transition name="slide-fade-right">
                    <div v-if="this[theColorPicker]" class="hide-color-picker" @click="hidePicker(theColorPicker)">

                        <i class="fas fa-times"></i>

                    </div>
                </transition>
            
            </div>

            

            <transition name="slide-fade">

                <chromePicker v-model="settingsFromWeebly.settings[elementRef]" @input="updateColor" v-if="this[theColorPicker]" class="color-picker-tool" />
                
            
            </transition>

        </b-form-group>

    </div>

</template>


<script>

import { Chrome } from 'vue-color'
                
export default {

    name: 'Mycolorpicker',

    props: ['elementRef', 'theColorPicker', 'colorPickerName'],

    data() {

        return {
            // color for color picker default -- will be overwritten
            colors: '#fff',

            // initial hide of all color pickers
            allpickers: false,

            curColorPicker: '',
            curPicker: ''

        } 

    },

    mounted() {

    },
    
    methods: {

        // color picker show
        showPicker(picker, colorPickerRef) {
            
            console.log('elementRef: ', this.elementRef)

            // hide possible open picker
            if(this[this.curPicker]) {

                this[this.curPicker] = false

            }
            
            // set cur value for use in documentClick
            this.curColorPicker = colorPickerRef
            this.curPicker = picker
            
            // add event listener
            document.addEventListener('click', this.documentClick)

            // open the correct color picker only
            this[picker] = true
            
        },

        // hide color picker
		hidePicker(picker) {

			document.removeEventListener('click', this.documentClick)
            this[picker] = false

        },

        // close picker on document click
        documentClick(event) {

			var el = this.$refs[this.curColorPicker],
                target = event.target;

			if(el !== target && !el.contains(target)) {

                this.hidePicker(this.curPicker)
                
            } 

        },

        // update color
        updateColor(color){

            this.$store.state.weeblySettings.settings[this.curColorPicker] = 'rgba('+color.rgba.r+','+color.rgba.g+','+color.rgba.b+','+color.rgba.a+')'

        }

    },

    components: {

        'chromePicker': Chrome

    },
    computed:{

        settingsFromWeebly() {

            return this.$store.state.weeblySettings
            
        },

        correctColorValue() {
            // if(settingsFromWeebly.settings[elementRef]) {
            //     return settingsFromWeebly.settings[elementRef]
            // } else {
            //     return settingsFromWeebly.settings.childBlocks[indexNr][elementRef]
            // }
            return this.$store.state.weeblySettings.settings[this.elementRef] === true ? this.$store.state.weeblySettings.settings[this.elementRef] : settingsFromWeebly.settings.childBlocks[indexNr][this.elementRef]
        }
        

    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';

.color-picker-wrapper-field {
    width: 100%;
    height: 31px;
    padding: 6px;
    border: 1px solid @border_grey_dark;
    border-radius: 0.25rem;
    background: @white;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    transition: padding-right .3s ease;

    &.partial-width {
        padding-right: 38px;
    }

    .color-picker-wrapper-field-preview {
        height: 17px;
        border-radius: 0.25rem;
        border: 1px solid rgba(0,0,0,.1);
    }

    .hide-color-picker {
        position: absolute;
        right: 1px;
        z-index: 10;
        background: #fff;
        top: 2px;
        cursor: pointer;
        bottom: 2px;
        line-height: 25px;
        width: 31px;
        text-align: center;
        border-left: 1px solid @border_grey_dark;

        i {
            font-size: 12px;
            color: @subtitle_grey;
        }

        &:hover i {
            color: @text_grey;
        }
    }
}

.color-picker-group {
    position: relative;

    .color-picker-tool {
        position: absolute;
        margin-top: 7px;
        left: 0;
        z-index: 10;
        width: 100%;
        box-shadow: 0 0 2px rgba(0,0,0,.15), 0 4px 8px rgba(0,0,0,.15);
        border-radius: .25rem;
        font-family: 'Lato', sans-serif;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/elements/elementSettings/Mycolorpicker.vue